module.exports = __webpack_public_path__ + "static/media/SharepointIcon.2bcc039d.png";